module.exports = __webpack_public_path__ + "img/close_square.70ce9ba2.svg";